import { Box, Flex } from '@mantine/core'

import { AdvisorTransactionItem } from '@/modules/advisors/users/pages/[id]/components/AdvisorTransactionItem/AdvisorTransactionItem'
import type { AdvisorTransactionsListProps } from '@/modules/advisors/users/pages/[id]/components/AdvisorTransactionsList/AdvisorTransactionsList.types'

import { ScrollArea } from '@/components/ScrollArea/ScrollArea'
import { Text } from '@/components/Text/Text'

export function AdvisorTransactionsList({
  transactions: rawTransactions,
  type,
}: AdvisorTransactionsListProps) {
  const transactions = rawTransactions?.filter(
    transaction => Math.abs(transaction.amount) >= 1,
  )

  if (!transactions?.length) {
    return (
      <Box>
        <Text>No transactions found</Text>
        <Text variant="body_4_gray">
          If the user added a new account recently, transactions may appear
          later.
        </Text>
      </Box>
    )
  }

  return (
    <ScrollArea
      h={{
        base: transactions.length > 5 ? 500 : 'auto',
        sm: transactions.length > 13 ? 1000 : 'auto',
      }}
      scrollbars="xy"
    >
      <Flex direction="column" gap={16}>
        {transactions.map(transaction => (
          <AdvisorTransactionItem
            key={transaction.id}
            transaction={transaction}
            type={type}
          />
        ))}
      </Flex>
    </ScrollArea>
  )
}
